import { isFlagEnabled } from "js/utilities";
import { default as ReleasingDeleteNonAutopayPaymentModal } from "./DeleteNonAutopayPaymentModal";
import DeprecatedDeleteNonAutopayPaymentModal from "./DeprecatedDeleteNonAutopayPaymentModal";

export default function DeleteNonAutopayPaymentModal({
  modalState,
  setModalState,
  data,
  policies,
  isUpdated,
  setIsUpdated,
  setToastDetail,
}) {
  return isFlagEnabled("ENABLE_RECURRING_PAYMENTS") ? (
    <ReleasingDeleteNonAutopayPaymentModal
      modalState={modalState}
      setModalState={setModalState}
      data={data}
      policies={policies}
      isUpdated={isUpdated}
      setIsUpdated={setIsUpdated}
      setToastDetail={setToastDetail}
    />
  ) : (
    <DeprecatedDeleteNonAutopayPaymentModal
      modalState={modalState}
      setModalState={setModalState}
      data={data}
      policies={policies}
      isUpdated={isUpdated}
      setIsUpdated={setIsUpdated}
      setToastDetail={setToastDetail}
    />
  );
}
